const clubsAssosText = {
  associationTitle: "Les associations",
  clubsTitle: "Les clubs",
};

export default clubsAssosText;
